module.exports = "/images/vendor/vue-paycard/src/amex.png?9a7fdab9dae0c2796257004c220d8ee3";